import { render } from "./loading.vue?vue&type=template&id=7a46c54c&scoped=true"
import script from "./loading.vue?vue&type=script&lang=js"
export * from "./loading.vue?vue&type=script&lang=js"

import "./loading.vue?vue&type=style&index=0&id=7a46c54c&scoped=true&lang=css"

import exportComponent from "/var/www/birchplace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a46c54c"]])

export default __exports__